import React, {useEffect, useState} from "react";
import PaginationComponent from "./pagination.component";
import LoadingSvg from "../images/svg/loading-trans.svg"
import TableExpandableComponent from "./table-expandable.component";

const TableComponent = (props) => {
    const {
        columns,
        dataSource,
        selectedRowKeys,
        onChangeSelectedRowKeys,
        selectedRows,
        tableClassName,
        headerClassName,
        emptyComponent,
        pagination,
        loading,
        expandableRow
    } = props
    const [selectedRowsState, setSelectedRowsState] = useState([])

    useEffect(() => {
        setSelectedRowsState(selectedRows ? selectedRows : [])
    }, [selectedRows])

    const onCheckedAllHandler = (e) => {
        if (e.target.checked) {
            let data = getRowKeys(dataSource)
            onChangeSelectedRowKeys(data.rowKeys, dataSource)
        } else {
            onChangeSelectedRowKeys([], [])
        }
    }

    const getRowKeys = (data) => {
        let rowKeys = []
        let rows = []
        data.forEach(item => {
            rowKeys.push(item.id)
            rows.push(item)
        })

        return {rowKeys, rows}
    }

    const onCheckHandler = (e, value) => {
        let rowKeys = []
        let rows = []

        if (e.target.checked) {
            rowKeys = [...selectedRowKeys, value.id]
            rows = [...selectedRowsState, value]
        } else {
            rowKeys = selectedRowKeys.filter((item) => item !== value.id)
            rows = selectedRowsState.filter((item) => item.id !== value.id)
        }

        setSelectedRowsState(rows)
        onChangeSelectedRowKeys(rowKeys, rows)
    }

    const bodyComponent = () => {
        let rows = []
        dataSource.map((item, index) => {
            const mainRows = (
                <tr className={!expandableRow ? "border-b" : undefined} key={index.toString()}>
                    {
                        columns.map((columnItem, idx) => {
                                if (idx === 0 && !!selectedRowKeys) {
                                    return (
                                        <td key={index.toString().concat(idx.toString())}
                                            className={"w-5"}>
                                            <div
                                                className={"col items-center justify-around p-1"}>
                                                <input type={"checkbox"}
                                                       className={"accent-green-grey my-5"}
                                                       checked={selectedRowKeys.includes(item.id)}
                                                       onChange={(e) => onCheckHandler(e, item, index)}/>
                                            </div>
                                        </td>
                                    )
                                } else {
                                    if (!!columnItem.render) {
                                        if (!!columnItem.dataIndex) {
                                            return <td colSpan={item?.colSpan ?? 1}
                                                       key={index.toString().concat(idx.toString())}>{columnItem.render(item[columnItem.dataIndex], item, idx)}</td>
                                        } else {
                                            return <td colSpan={item?.colSpan ?? 1}
                                                       key={index.toString().concat(idx.toString())}>{columnItem.render(item, index)}</td>
                                        }
                                    } else {
                                        return <td key={index.toString().concat(idx.toString())}
                                                   colSpan={item?.colSpan ?? 1}
                                                   className={columnItem.className}>{item[columnItem.dataIndex]}</td>
                                    }
                                }
                            }
                        )
                    }
                </tr>
            )
            rows.push(mainRows)

            if (!!expandableRow) {
                const expandRows = (
                    <tr key={String(index + 11)} className={"border-b"}>
                        <td colSpan={7}>
                            <TableExpandableComponent content={expandableRow(item.awb_error, {order_id: item.id, courier: item?.awb_error?.courier})}/>
                        </td>
                    </tr>
                )
                rows.push(expandRows)
            }
        })

        return rows
    }

    return (
        <div className={"px-5"}>
            <table className={`${tableClassName} w-full order-table`}>
                <thead className={headerClassName}>
                <tr>
                    {
                        columns.map((item, index) => {
                            switch (item.type) {
                                case "checkbox":
                                    return !!selectedRowKeys && (
                                        <th data-priority={(index + 1).toString()} key={index.toString()}
                                            className={"w-5"}>
                                            <div
                                                className={"col items-center justify-around"}>
                                                <input type={"checkbox"} className={"accent-green-grey"}
                                                       checked={selectedRowKeys.length > 0 && (selectedRowKeys.length === dataSource.length)}
                                                       onChange={e => onCheckedAllHandler(e)}/>
                                            </div>
                                        </th>
                                    )
                                default:
                                    return (
                                        <th width={item.width}
                                            className={item.classNameHeader}
                                            data-priority={(index + 1).toString()} key={index.toString()}>
                                            <div>{item.name}</div>
                                        </th>
                                    )
                            }
                        })
                    }
                </tr>
                </thead>
                {
                    !loading &&
                    <tbody>
                    {bodyComponent()}
                    </tbody>
                }
            </table>
            {loading ?
                <div className={"w-full row justify-center mt-5"}>
                    <img src={LoadingSvg} className={"w-12"}/>
                </div> :
                dataSource.length === 0 && (!!emptyComponent ? emptyComponent() :
                    <div
                        className={"flex flex-row justify-center mt-20 items-center text-milano-red font-FuturaBT-Book"}>No
                        data
                    </div>)
            }
            {dataSource.length === 0 ? null : !!pagination && <PaginationComponent/>}
        </div>
    )
}

export default TableComponent
